<template>
  <div class="dialog">
    <van-dialog v-model="visible" :title="title" @confirm="confirm">
      <div v-if="type == 'yes'" class="box">
        <div>
          在您确认金额后，预计{{ payMoneyDays }}会由{{ insuranceName }}支付理赔款到您上传的银行卡中，还请耐心等待并随时关注银行卡到账信息
        </div>
        <div>
          注意：农村信用社，农村商业银行，中信银行到账时间较慢，还请耐心等待
        </div>
        <div>
          如遇节假日前后，或遇特殊情况，银行批量打款会有延迟，请耐心等待到账即可
        </div>
      </div>
      <div v-if="type == 'no'" class="box">
        <div v-if="isGuidToYou == 'no'">
          若您对理赔金额有异议，{{ insuranceName }}专员将会在3个工作日内与您再次电话联系，请您保持电话畅通；
        </div>
        <div v-else>若您对理赔金额有异议，可以在柚儿健康公众号上简单描述您对理赔金额的疑问，公众号客服人员会给您做初步说明</div>
        <div>
          <p>如有疑问，可拨打{{ insuranceName }}座机：</p>
          <p>{{ phone }}</p>
          <p>工作时间：{{insuranceWorkTime1}}</p>
          <p>{{insuranceWorkTime2}}</p>
          <p>{{insuranceWorkTime3}}</p>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
export default {
  name: "Dialog",
  props: {
    visible: {
      typeof: Boolean,
      default: false,
    },
    type: {
      typeof: String,
      default: "",
    },
    phone: {
      typeof: String,
      default: "",
    },
    insuranceName: {
      typeof: String,
      default:""
    },
    payMoneyDays: {
      typeof: String,
      default:""
    },
    insuranceWorkTime1: {
      typeof: String,
      default:""
    },
    insuranceWorkTime2: {
      typeof: String,
      default:""
    },
    insuranceWorkTime3: {
      typeof: String,
      default:""
    },
    isGuidToYou:{
      typeof: String,
      default:"no"
    }

  },
  computed: {
    title() {
      let str = "";
      switch (this.type) {
        case "yes":
          str = "您已确认理赔金额";
          break;
        case "no":
          str = "金额有异议";
          break;
      }
      return str;
    },
  },
  data() {
    return {};
  },
  methods: {
    confirm() {
      this.$emit("dialog");
    },
  },
};
</script>
<style scoped lang="less">
.dialog {
  .box {
    padding: 10px 20px;

    div {
      margin-bottom: 10px;
      .confirmed-red {
        font-weight: 600;
        color: red;
      }
      .confirmed-bold {
        font-weight: 600;
      }
    }
  }
  /deep/.van-dialog__header {
    font-size: 20px;
  }
  /deep/.van-dialog__confirm {
    background: #f1a705;
    color: #fff;
  }
}
</style>
